<template>
  <div>
    <div class="crancy-smenu" :class="{ 'crancy-close': closeMenu, 'has-notification': missingStore }" id="CrancyMenu">
      <!-- Admin Menu -->
      <div class="admin-menu">

        <!-- Logo -->
        <div class="logo crancy-sidebar-padding pd-right-0">
          <div @click="$router.push('/')" class="crancy-logo" href="/">
            <!-- Logo for Default -->
            <img class="crancy-logo__main" alt="Coinsnap" src="../assets/img/logo.png">
            <img class="crancy-logo__main--small" src="../assets/img/logo.png" alt="Coinsnap">
          </div>
        </div>

        <!-- Main Menu -->
        <div class="admin-menu__one crancy-sidebar-padding mg-top-20">
          <!-- Nav Menu -->
          <div class="menu-bar">
            <ul id="CrancyMenu" class="menu-bar__one crancy-dashboard-menu">
              <li v-if="isAdmin">
                <a class="collapsed" href="#!"
                   :class="{
                           'selectedDropdown': adminDropdown,
                           'active-parent': isAdminSection
                         }"
                   @click.prevent="toggleDropdown('admin')">
                  <span class="menu-bar__text">
                    <span class="crancy-menu-icon crancy-svg-icon__v1">
                      <i class="fa-solid fa-chart-simple"></i>
                    </span>
                    <span class="menu-bar__name">{{ $t("Admin Overview") }}</span>
                  </span>
                  <span class="crancy__toggle"></span>
                </a>
                <div v-show="adminDropdown || isAdminSection" class="crancy__dropdown">
                  <ul class="menu-bar__one-dropdown">
                    <li>
                      <router-link
                          class="nav-link dropdownLink"
                          :class="{ 'active': $route.path === '/admin-transactions' }"
                          to="/admin-transactions">
                        <span @click="toggleNavMenu" class="menu-bar__text">
                          <span class="menu-bar__name">{{ $t("Transaction Overview") }}</span>
                        </span>
                      </router-link>
                      <router-link class="nav-link dropdownLink" :class="{ 'active': $route.path === '/merchant-list' }"
                                   to="/merchant-list">
                        <span @click="toggleNavMenu" class="menu-bar__text">
                          <span class="menu-bar__name">{{ $t("Merchant list") }}</span>
                        </span>
                      </router-link>
                      <router-link class="nav-link dropdownLink"
                                   :class="{ 'active': $route.path === '/monthly-statements' }"
                                   to="/monthly-statements">
                        <span @click="toggleNavMenu" class="menu-bar__text">
                          <span class="menu-bar__name">{{ $t("Monthly Statements") }}</span>
                        </span>
                      </router-link>
                      <router-link class="nav-link dropdownLink" :class="{ 'active': $route.path === '/stats' }"
                                   to="/stats">
                        <span @click="toggleNavMenu" class="menu-bar__text">
                          <span class="menu-bar__name">{{ $t("Admin Stats") }}</span>
                        </span>
                      </router-link>
                      <router-link class="nav-link dropdownLink" :class="{ 'active': $route.path === '/admin-alerts' }"
                                   to="/admin-alerts">
                        <span @click="toggleNavMenu" class="menu-bar__text">
                          <span class="menu-bar__name">{{ $t("Admin Alerts") }}</span>
                        </span>
                      </router-link>
                    </li>
                  </ul>
                </div>
              </li>
              <li @click="toggleNavMenu">
                <router-link class="collapsed" to="/cs" :class="{ 'active': $route.path === '/cs' }">
                  <span class="menu-bar__text">
                    <span class="crancy-menu-icon crancy-svg-icon__v1">
                       <i class="fa-solid fa-chart-line"></i>
                    </span>
                    <span class="menu-bar__name">{{ $t("Dashboard") }}</span>
                  </span>
                </router-link>
              </li>
              <li>
                <a class="collapsed" href="#!" data-bs-toggle="collapse" data-bs-target="#menu-item__dashboard"
                   :class="{
                           'selectedDropdown': paymentDropdown,
                           'active-parent': isPaymentSection
                         }"
                   @click.prevent="toggleDropdown('payment')">
                  <span class="menu-bar__text">
                    <span class="crancy-menu-icon crancy-svg-icon__v1">
                      <i class="fa-solid fa-cash-register"></i>
                    </span>
                    <span class="menu-bar__name">{{ $t("Payment Tools") }}</span>
                  </span>
                  <span class="crancy__toggle"></span>
                </a>

                <div v-show="paymentDropdown || isPaymentSection" class="crancy__dropdown">
                  <ul class="menu-bar__one-dropdown">
                    <li>
                      <router-link class="nav-link dropdownLink" :class="{ 'active': $route.path === '/web-pos' }" to="/web-pos">
                        <span @click="toggleNavMenu" class="menu-bar__text">
                          <span class="menu-bar__name">{{ $t("Web-PoS") }}</span>
                        </span>
                      </router-link>
                      <router-link class="nav-link dropdownLink" :class="{ 'active': $route.path === '/payment-requests' }" to="/payment-requests">
                        <span @click="toggleNavMenu" class="menu-bar__text">
                          <span class="menu-bar__name">{{ $t("Pay-Link") }}</span>
                        </span>
                      </router-link>
                      <router-link class="nav-link dropdownLink" :class="{ 'active': $route.path === '/payment-buttons' }" to="/payment-buttons">
                        <span @click="toggleNavMenu" class="menu-bar__text">
                          <span class="menu-bar__name">{{ $t("Pay-Button") }}</span>
                        </span>
                      </router-link>
                      <router-link class="nav-link dropdownLink" :class="{ 'active': $route.path === '/invoice-form' }" to="/invoice-form">
                        <span @click="toggleNavMenu" class="menu-bar__text">
                          <span class="menu-bar__name">{{ $t("Invoice-Form") }}</span>
                        </span>
                      </router-link>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="">
                <a class="collapsed" href="#!" data-bs-toggle="collapse" data-bs-target="#menu-item__dashboard"
                   :class="{
                             'selectedDropdown': financesDropdown,
                             'active-parent': isFinanceSection
                           }"
                   @click.prevent="toggleDropdown('finances')">
                  <span class="menu-bar__text">
                    <span class="crancy-menu-icon crancy-svg-icon__v1">
                      <i class="fa-solid fa-coins"></i>
                    </span>
                    <span class="menu-bar__name">{{ $t("Finances") }}</span>
                  </span>
                  <span class="crancy__toggle"></span>
                </a>

                <div v-show="financesDropdown || isFinanceSection" class="crancy__dropdown">
                  <ul class="menu-bar__one-dropdown">
                    <li>
                      <router-link class="nav-link dropdownLink" :class="{ 'active': $route.path === '/transactions' }" to="/transactions">
                        <span @click="toggleNavMenu" class="menu-bar__text">
                          <span class="menu-bar__name">{{ $t("Transaction Center") }}</span>
                        </span>
                      </router-link>
                      <router-link class="nav-link dropdownLink" :class="{ 'active': $route.path === '/commissions' }" to="/commissions">
                        <span @click="toggleNavMenu" class="menu-bar__text">
                          <span class="menu-bar__name">{{ $t("Commission Center") }}</span>
                        </span>
                      </router-link>
                      <router-link class="nav-link dropdownLink" :class="{ 'active': $route.path === '/accounting' }" to="/accounting">
                        <span @click="toggleNavMenu" class="menu-bar__text">
                          <span class="menu-bar__name">{{ $t("Accounting Center") }}</span>
                        </span>
                      </router-link>
                      <router-link class="nav-link dropdownLink" :class="{ 'active': $route.path === '/reports' }" to="/reports">
                        <span @click="toggleNavMenu" class="menu-bar__text">
                          <span class="menu-bar__name">{{ $t("Reports") }}</span>
                        </span>
                      </router-link>
                    </li>
                  </ul>
                </div>
              </li>
              <li @click="toggleNavMenu">
                <router-link class="collapsed" :class="{ 'active': $route.path === '/notifications' }" to="/notifications">
                  <span class="menu-bar__text">
                    <span class="crancy-menu-icon crancy-svg-icon__v1">
                      <i class="fa-solid fa-message"></i>
                    </span>
                    <span class="menu-bar__name">{{ $t("Notifications") }}</span>
                  </span>
                </router-link>
              </li>
              <li @click="toggleNavMenu">
                <router-link class="collapsed" :class="{ 'active': $route.path === '/referral' }" to="/referral">
                  <span class="menu-bar__text">
                    <span class="crancy-menu-icon crancy-svg-icon__v1">
                      <i class="fa-solid fa-users"></i>
                    </span>
                    <span class="menu-bar__name">{{ $t("Referral area") }}</span>
                  </span>
                </router-link>
              </li>
              <li @click="toggleNavMenu">
                <router-link class="collapsed" :class="{ 'active': $route.path === '/support' }" to="/support">
                  <span class="menu-bar__text">
                    <span class="crancy-menu-icon crancy-svg-icon__v1">
                      <i class="fa-solid fa-headset"></i>
                    </span>
                    <span class="menu-bar__name">{{ $t("Support") }}</span>
                  </span>
                </router-link>
              </li>
              <li @click="toggleNavMenu">
                <router-link class="collapsed" :class="{ 'active': $route.path === '/settings' }" to="/settings">
                  <span class="menu-bar__text">
                    <span class="crancy-menu-icon crancy-svg-icon__v1">
                      <i class="fa-solid fa-gear"></i>
                    </span>
                    <span class="menu-bar__name">{{ $t("Settings") }}</span>
                  </span>
                </router-link>
              </li>
              <li @click="toggleNavMenu">
                <router-link class="collapsed" :class="{ 'active': $route.path === '/webhooks' }" to="/webhooks">
                  <span class="menu-bar__text">
                    <span class="crancy-menu-icon crancy-svg-icon__v1">
                      <i class="fas fa-share-alt"></i>
                    </span>
                    <span class="menu-bar__name">{{ $t("Webhooks") }}</span>
                  </span>
                </router-link>
              </li>
              <li>
                <a class="collapsed" @click="logout">
                  <span class="menu-bar__text">
                    <span class="crancy-menu-icon crancy-svg-icon__v1">
                      <i class="fa-solid fa-right-from-bracket"></i>
                    </span>
                    <span class="menu-bar__name">{{ $t("Logout") }}</span>
                  </span>
                </a>
              </li>
            </ul>
          </div>
          <!-- End Nav Menu -->
        </div>

        <div class="crancy-sidebar-padding pd-btm-40">
          <div class="crancy-support-card crancy-bg-cover">
            <div class="crancy-support-card__sing">
              <img src="../assets/img/support-sign-icon.svg">
            </div>
            <h4 class="crancy-support-card__title">{{ $t("Help Center") }}</h4>
            <p class="crancy-support-card__text">{{
                $t('Having trouble Dashboard? Please contact us for more question?')
              }}</p>
            <a target="_blank" href="https://coinsnap.io/"
               class="crancy-btn crancy-ybcolor mg-top-20">{{ $t("Go To Help Center") }}</a>
          </div>
          <!-- End Support Card -->
        </div>
      </div>
      <!-- End Admin Menu -->
    </div>
    <div @click="toggleNavMenu" id="menu-icon" :class="{ 'open': closeMenu }">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <header class="crancy-header" :class="{ 'crancy-close': closeMenu, 'has-notification': missingStore }">
      <Notification
          v-if="missingStore"
          :show="missingStore"
          message="To begin accepting payments and unlock all features, you need to link your store! Click <a href='/'>here</a> to enter details.">
      </Notification>
      <div class="container g-0">
        <div class="row g-0">
          <div class="col-12">
            <!-- Dashboard Header -->
            <div class="crancy-header__inner">
              <div class="crancy-header__middle">

                <div class="crancy-header__left">
                  <div class="crancy-header__nav-bottom">
                    <!-- Logo -->
                    <div class="logo crancy-sidebar-padding">
                      <a class="crancy-logo" href="/">
                        <!-- Logo for Default -->
                        <img class="crancy-logo__main" alt="Coinsnap" src="../assets/img/logo.png">
                        <img class="crancy-logo__main--small" src="../assets/img/logo.png" alt="Coinsnap">
                      </a>
                    </div>
                  </div>
                </div>
                <div class="crancy-header__right">
                  <div class="crancy-header__group">
                    <div class="crancy-header__group-two">
                      <div class="crancy-header__right">

                        <div class="crancy-header__dropdown">
                          <div class="crancy-header__dropdown--single crancy-language" @click="toggleLangMenu"
                               :class="{ 'open': closeLangMenu }">
                            <div class="language-switcher d-flex align-items-center">
                              <div class="language-item" v-if="this.language === 'en'">
                                <img src="../assets/img/flag-1.png">
                                <span>{{ $t("English") }}</span>
                              </div>
                              <div class="language-item" v-if="this.language === 'de'">
                                <img src="../assets/img/flag-3.jpg">
                                <span>{{ $t("German") }}</span>
                              </div>
                              <div class="language-item" v-if="this.language === 'es'">
                                <img src="../assets/img/flag-4.png">
                                <span>{{ $t("Spanish") }}</span>
                              </div>
                              <div class="language-item" v-if="this.language === 'fr'">
                                <img src="../assets/img/flag-2.jpg">
                                <span>{{ $t("French") }}</span>
                              </div>
                              <i class="fa-solid fa-angle-down"></i>
                            </div>
                            <div id="text" class="crancy-balance crancy-language__list">
                              <a @click="language = 'en'; saveLangSettins()" href="#">
                                <img src="../assets/img/flag-1.png"><span>{{ $t("English") }}</span>
                              </a>
                              <a @click="language = 'de'; saveLangSettins()" href="#">
                                <img src="../assets/img/flag-3.jpg"><span>{{ $t("German") }}</span>
                              </a>
                              <a @click="language = 'es'; saveLangSettins()" href="#">
                                <img src="../assets/img/flag-4.png"><span>{{ $t("Spanish") }}</span>
                              </a>
                              <a @click="language = 'fr'; saveLangSettins()" href="#">
                                <img src="../assets/img/flag-2.jpg"><span>{{ $t("French") }}</span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <!-- Header Zoom -->
                        <div class="crancy-header__zoom">
                          <button @click=toggleFullSize() id="crancy-header__full">
                            <i class="fa-solid fa-expand"></i>
                          </button>
                        </div>
                        <!-- End Header Zoom -->
                        <AlertsWidget :alerts="this.alertsData"></AlertsWidget>

                        <!-- Header Option Group -->
                        <div class="crancy-header__options">
                          <div class="crancy-header__settings">
                            <button id="crancy-header__settings">
                              <router-link to="/settings">
                                <i class="fa-solid fa-gear"></i>
                              </router-link>

                            </button>
                          </div>
                          <!-- Header Nav -->
                        </div>
                        <UserProfile></UserProfile>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import {getCookie} from '@/assets/js/sharedFunctions';
import Notification from "@/components/Notification.vue";
import UserProfile from "@/components/UserProfile.vue";
import AlertsWidget from "@/views/alerts/AlertsWidget.vue";

export default {
  name: "Navbar",
  components: {AlertsWidget, UserProfile, Notification},
  data() {
    return {
      financesDropdown: false,
      adminDropdown: false,
      paymentDropdown: false,
      closeMenu: false,
      closeLangMenu: false,
      fullSize: false,
      langChanged: false,
      language: "",
      saveError: false,
      changesSaved: false,
      isAdmin: false,
      loaded: false,
    }
  },
  computed: {
    alertsData() {
      return this.$store.getters.getAlertsData || {};
    },
    apiData() {
      return this.$store.getters.getApiData;
    },
    missingStore() {
      // Return false if apiData is undefined/null (initial state)
      if (this.apiData === undefined || this.apiData === null) {
        return false;
      }
      return !this.apiData.hasStore;
    },
    isAdminSection() {
      const adminRoutes = ['/admin-transactions', '/merchant-list', '/monthly-statements', '/stats'];
      return adminRoutes.includes(this.$route.path);
    },
    isPaymentSection() {
      const paymentRoutes = ['/web-pos', '/payment-requests', '/payment-buttons', '/invoice-form', '/invoice-form-link'];
      return paymentRoutes.includes(this.$route.path);
    },
    isFinanceSection() {
      const financeRoutes = ['/transactions', '/commissions', '/accounting', '/reports'];
      return financeRoutes.includes(this.$route.path);
    },
  },
  watch: {
    language(newVal, oldVal) {
      if (oldVal !== "" && newVal !== oldVal) {
        this.langChanged = true
      }
      this.$i18n.locale = newVal
      let expirationDate = new Date();
      expirationDate.setTime(expirationDate.getTime() + (365 * 24 * 60 * 60 * 1000));
      document.cookie = `coinsnap-i18n=${newVal}  expires=${expirationDate.toUTCString()}; path=/`
      if (oldVal !== "") {
        this.$store.dispatch('putApiCallAction', {
          'hook': '/users/modify',
          'body': {'preferredLanguage': newVal},
        })
      }
    },
    '$route'(to) {
      // Set dropdown state based on current route section
      this.adminDropdown = this.isAdminSection;
      this.paymentDropdown = this.isPaymentSection;
      this.financesDropdown = this.isFinanceSection;
    }
  },
  methods: {
    logout() {
      this.$store.dispatch("getLogout")
    },
    toggleDropdown(type) {
      const dropdowns = {
        payment: 'paymentDropdown',
        finances: 'financesDropdown',
        admin: 'adminDropdown',
      };

      // Close all other dropdowns
      Object.keys(dropdowns).forEach(key => {
        if (key !== type) {
          this[dropdowns[key]] = false;
        }
      });

      // Toggle the clicked dropdown
      this[dropdowns[type]] = !this[dropdowns[type]];
    },

    toggleDropdownOFF() {
      // Only close dropdowns if we're not in their sections
      if (!this.isAdminSection) this.adminDropdown = false;
      if (!this.isPaymentSection) this.paymentDropdown = false;
      if (!this.isFinanceSection) this.financesDropdown = false;
    },
    toggleNavMenu() {
      if (window.innerWidth < 1280) {
        this.closeMenu = !this.closeMenu;
        this.$emit('updateValue', this.closeMenu);
      }
    },
    toggleLangMenu() {
      this.closeLangMenu = !this.closeLangMenu
    },
    toggleFullSize() {
      this.fullSize = !this.fullSize
      const htmlElement = document.documentElement;

      if (!this.fullSize) {
        document.exitFullscreen();
      } else {
        htmlElement.requestFullscreen();
      }
    },
    saveLangSettins() {
      let settings = {};

      if (this.langChanged) {
        settings.preferredLanguage = this.language;
      }

      // Early exit if no changes
      if (Object.keys(settings).length === 0) {
        new Promise((resolve) => window.setTimeout(resolve, 500)).then(() => {
          this.spinnerSave = false;
          this.changesSaved = true;
        });
        new Promise((resolve) => window.setTimeout(resolve, 2000)).then(() => {
          this.changesSaved = false;
          this.saveError = false;
        });
        return;
      }

      // Update the Vuex store immediately for reactivity
      const updatedApiData = {
        ...this.$store.state.apiData,
        language: this.language,
      };
      this.$store.commit('SET_API_DATA', updatedApiData);

      // Send the API call to save the new language
      this.$store
          .dispatch('putApiCallAction', {
            hook: '/users/modify',
            body: settings,
          })
          .then((res) => {
            new Promise((resolve) => window.setTimeout(resolve, 500)).then(() => {
              this.spinnerSave = false;
              this.changesSaved = true;

              if (res && res.status === 200) {
                Object.keys(settings).forEach((s) => {
                  this[s] = settings[s];
                });
              } else {
                this.saveError = true;
              }

              new Promise((resolve) => window.setTimeout(resolve, 2000)).then(() => {
                this.changesSaved = false;
                this.saveError = false;
              });
            });
          });
    },
  },
  mounted() {
    this.adminDropdown = this.isAdminSection;
    this.paymentDropdown = this.isPaymentSection;
    this.financesDropdown = this.isFinanceSection;

    // Add click outside listener to close dropdowns
    document.addEventListener('click', (e) => {
      const menu = document.getElementById('CrancyMenu');
      if (menu && !menu.contains(e.target)) {
        this.toggleDropdownOFF();
      }
    });

    const cookie = getCookie('cn-token')
    if (cookie) {
      this.$store.dispatch("getApiCallAction", {hook: '/settings'}).then(res => {
        const languageCookie = getCookie("coinsnap-i18n")?.split(" expires")[0]?.replace(/\s+/g, '')
        if (res.language) {
          document.cookie = `coinsnap-i18n=${this.language}  expires=-1; path=/`
          this.language = res.language
          let expirationDate = new Date();
          expirationDate.setTime(expirationDate.getTime() + (365 * 24 * 60 * 60 * 1000));
          document.cookie = `coinsnap-i18n=${this.language}  expires=${expirationDate.toUTCString()}; path=/`
        } else if (languageCookie) {
          this.language = languageCookie
        }
      })

      this.$store.dispatch("getApiCallAction", {hook: '/user/session'}).then((res) => {
        this.isAdmin = res.isAdmin === 1;
      });
    }
  },
  beforeDestroy() {
    // Clean up click outside listener
    document.removeEventListener('click', this.toggleDropdownOFF);
  }
};
</script>

